import { touchWebClient } from 'tradera-utils/http';

export const getCategoryList = () =>
    touchWebClient.get('categories', { cancelTokenId: 'getCategoryList' });
